module.exports = __webpack_public_path__ + "static/media/Icon_Handyman.332c04b4.png";